import { render, staticRenderFns } from "./PhoneNumber2.vue?vue&type=template&id=21965b2b&"
import script from "./PhoneNumber2.vue?vue&type=script&lang=js&"
export * from "./PhoneNumber2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports